/**
Project: Voice Panel (c)
Title: Adal Config 
Description: Config file for ADAL 
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/

//import * as microsoftTeams from "@microsoft/teams-js";

const azureActiveDirectoryAppId =
  process.env.REACT_APP_AZURE_ACTIVE_DIRECTORY_APP_ID;
//export const initialization = microsoftTeams.initialize();
export const adalConfig = {
  // tenant: "153dbfdf-3c04-4839-baa9-a302f57e0c25",
  clientId: azureActiveDirectoryAppId,
  // endpoints: {
  //   api: window.location.origin + "/browser-redirect",
  // },
  cacheLocation: "localStorage",
  // redirectUri: window.location.origin + "/signin-interactive-end",
  postLogoutRedirectUri: window.location.origin + "/signout-interactive",
  popUp: true,
  extraQueryParameter: "prompt=select_account",
};
